import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowDown,
  faArrowUp,
  faBold,
  faBracketsCurly,
  faClone,
  faGear,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faStrikethrough,
  faTrash,
  faUnderline,
} from "@fortawesome/pro-regular-svg-icons";
import {
  emailBuilderCanvasBlockRailActionTooltip,
  type TEmailBuilderCanvasBlockRailAction,
} from "./emailBuilderCanvasBlockInteractions";

export function railActionTooltip(
  action: TEmailBuilderCanvasBlockRailAction,
  t: (key: string) => string,
  isMac: boolean,
): string {
  return emailBuilderCanvasBlockRailActionTooltip(action, railActionLabel(action, t), isMac);
}

export function railActionLabel(
  action: TEmailBuilderCanvasBlockRailAction,
  t: (key: string) => string,
): string {
  switch (action) {
    case "move-earlier":
      return t("Move up");
    case "move-later":
      return t("Move down");
    case "merge-tag":
      return t("Merge tags");
    case "bold":
      return t("Bold");
    case "italic":
      return t("Italic");
    case "underline":
      return t("Underline");
    case "strikethrough":
      return t("Strikethrough");
    case "bulleted-list":
      return t("Bulleted list");
    case "numbered-list":
      return t("Numbered list");
    case "link":
      return t("Link");
    case "settings":
      return t("Settings");
    case "duplicate":
      return t("Duplicate");
    case "delete":
      return t("Delete");
  }
}

export function railActionIcon(
  action: TEmailBuilderCanvasBlockRailAction,
): IconDefinition {
  switch (action) {
    case "move-earlier":
      return faArrowUp;
    case "move-later":
      return faArrowDown;
    case "merge-tag":
      return faBracketsCurly;
    case "bold":
      return faBold;
    case "italic":
      return faItalic;
    case "underline":
      return faUnderline;
    case "strikethrough":
      return faStrikethrough;
    case "bulleted-list":
      return faListUl;
    case "numbered-list":
      return faListOl;
    case "link":
      return faLink;
    case "settings":
      return faGear;
    case "duplicate":
      return faClone;
    case "delete":
      return faTrash;
  }
}
